export function localize(obj) {
  return On.helpers.localize(obj)
}
